import React from "react";
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

export interface RadioOption {
  value: string;
  label: string;
}

interface RadioRowProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
}

export default function RadioRow({
  label,
  value,
  onChange,
  options,
}: RadioRowProps) {
  return (
    <>
      <Typography variant="subtitle1" fontWeight={500} mb={1}>
        {label}
      </Typography>

      <RadioGroup
        row
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
    </>
  );
}
